import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { push } from 'connected-react-router'

import { Row, Col, Form } from 'components/layout'
import { Button, Module } from 'components/misc'
import { RadioGroup, Radio } from 'components/fields'
import { form } from 'helpers/decorators'
import config from 'config'

@form({
  form: 'registerForm',
  disableHook: true
})
@connect(null, { push })
class Register extends Component {
  static propTypes = {
    values: PropTypes.object,
    push: PropTypes.func.isRequired,
    initialize: PropTypes.func
  }

  componentDidount = () => this.props.initialize({ registerFor: 'participant' })

  handleRegisterRedirect = () => {
    const { values } = this.props

    if (values && values.registerFor) {
      this.props.push(`${config.publicPath}/register/${values.registerFor}`)
    }
  }

  render() {
    return (
      <Module withFooter xs>
        <Form>
          <Row column spaceBetween>
            <Col />
            <Col>
              <h2 className="alpha-color base-margin--bottom">
                <FormattedMessage
                  id="moduleTitle.notRegistred"
                  defaultMessage="Not Registered?"
                />
              </h2>
              <RadioGroup
                label="Register a new account as:"
                intlKey="label.register_a_new_account_as"
                secondary
              >
                <Radio
                  label="Award Participant"
                  intlKey="label.award_participant"
                  name="registerFor"
                  value="participant"
                  dataTestId="participantRegistrationCheckbox"
                />
                <Radio
                  label="Award Leader"
                  intlKey="label.award_leader"
                  name="registerFor"
                  value="leader"
                />
                <Radio
                  label="Award Unit"
                  intlKey="label.award_unit"
                  name="registerFor"
                  value="award-unit"
                />
              </RadioGroup>
            </Col>
            <Button
              type="button"
              fluid
              onClick={() => this.handleRegisterRedirect()}
              disabled={!this.props.values}
              style={{ marginTop: 98 }}
              dataTestId="continueToRegistrationButton"
            >
              <FormattedMessage
                id="button.register"
                defaultMessage="Register"
              />
            </Button>
          </Row>
        </Form>
      </Module>
    )
  }
}

export default Register
